module.exports = __webpack_public_path__ + "static/banner-454ed9a83ad1949c81ef0a9aae406b1f.png";